/**
 * Return if user is logged in.
 *
 * The access/refresh tokens live in httpOnly cookies now (JS can't read
 * them at all), so this can only check the non-sensitive profile blob --
 * it's a fast synchronous UI hint for route gating, not a security check.
 * The real check is server-side: if the cookie is missing/expired, the
 * first API call 401s and jwtService's response interceptor redirects to
 * login (see src/@core/auth/jwt/jwtService.js).
 */
export const isUserLoggedIn = () => !!localStorage.getItem('userData')

/**
 * The stored profile blob, or null when there is none.
 *
 * Two ways this is null rather than an object, and callers must handle both:
 * localStorage has no `userData` at all (logged out, cleared by another tab,
 * storage wiped) -- note JSON.parse(null) yields null, not a throw -- or the
 * stored value is not valid JSON, which would otherwise throw out of a render.
 */
export const getUserData = () => {
  try {
    return JSON.parse(localStorage.getItem('userData'))
  } catch {
    return null
  }
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'coach') return '/'
  if (userRole === 'player') return { name: 'dashboard' }
  return { name: 'auth-login' }
}
